// extracted by mini-css-extract-plugin
export default {"container":"c0nQEv1B2","bigger":"cC7bMSAMj","paddingNone":"cd7H_Q__P"};